import React, { useEffect, useState, useRef } from "react";
import { PayPalButtons, usePayPalScriptReducer } from "@paypal/react-paypal-js";
import { useDispatch, useSelector } from "react-redux";

import PlaceOrdersService from "../../services/PlaceOrderService";
import { useNavigate, useParams } from "react-router-dom";

import {
  listAddress,
  listItems,
  listOrderDetails,
  setIsPaid,
} from "../../stores/order";

function PaypalButtonComponent() {
  const [{ options, isPending }, dispatch] = usePayPalScriptReducer();
  const params = useParams();
  const endpoint = `${params.id}`;
  const orderTotal = useSelector(
    (state) => state.order.orderdetails.totalprice
  );
  const mydispatch = useDispatch();
  const isPaid = useSelector((state) => state.order.isPaid);
  // console.log("State Data:" + isPaid);

  const onCreateOrder = (data, actions) => {
    return PlaceOrdersService.get(endpoint)
      .then((response) => {
        const datas = response.data.data[0];
        const amount = datas.totalprice;
        if (amount === undefined) {
          return 0;
        } else {
          return actions.order.create({
            purchase_units: [
              {
                amount: {
                  value: amount,
                },
              },
            ],
          });
        }
      })
      .catch((error) => {
        console.error("Error creating order:", error);
        // Handle error appropriately
      });
  };

  const onApproveOrder = (data, actions) => {
    const initialOrder = {
      id: null,
      paymentmethod: "Paypal",
      ispaid: 1,
      paidat: new Date().toLocaleString() + "",
    };

    // console.log(data);
    return actions.order.capture().then((details) => {
      PlaceOrdersService.update(endpoint, initialOrder)
        .then((response) => {
          // setServermessage("The Gallery was updated successfully!");
          // setSubmitted(true);
          // console.log("update Response:" + JSON.stringify(response));
          mydispatch(setIsPaid());
          const name = details.payer.name.given_name;
          alert(`Transaction completed by ${name}`);
        })
        .catch((e) => {
          // console.log(e.response.data.message);
          // setServermessage("Error: " + e.response.data.message);
          // setSubmitted(true);
        });
    });
  };

  useEffect(() => {}, [orderTotal, isPaid]);

  return (
    <div>
      {isPending ? (
        <p>LOADING...</p>
      ) : (
        <>
          <PayPalButtons
            style={{ layout: "vertical" }}
            // forceReRender={[totalAmount.totalprice]}
            // createOrder={(data, actions) => onCreateOrder(data, actions)}
            // onApprove={(data, actions) => onApproveOrder(data, actions)}
            createOrder={onCreateOrder}
            onApprove={onApproveOrder}
          />
        </>
      )}
    </div>
  );
}

export default PaypalButtonComponent;
